import { DEFAULT_SESSION_DURATION_MINUTES } from '@/constants';

import type { StytchResponse, User } from '@/types';

interface StytchSessionDurationClient {
  authenticate: (options: {
    session_duration_minutes: number;
  }) => Promise<unknown>;
}

export const ensureSessionTimeout = async (
  stytch: StytchSessionDurationClient,
  user: User,
  onSessionUpdated?: (response: StytchResponse) => Promise<void>,
): Promise<void> => {
  if (typeof user.sessionTimeoutLength !== 'number') return;

  const sessionDurationMinutes = Math.floor(user.sessionTimeoutLength / 60);
  if (sessionDurationMinutes === DEFAULT_SESSION_DURATION_MINUTES) return;

  const response = (await stytch.authenticate({
    session_duration_minutes: sessionDurationMinutes,
  })) as StytchResponse;
  await onSessionUpdated?.(response);
};
